import React, { PureComponent } from 'react';
import { Button, message, Modal, Icon } from 'antd';
import { connect } from 'react-redux';
import * as actions from '../../../actions';

export const ACTION_STATUS = {
  NEW: 'new',
  TAKEN: 'taken',
  IN_REVIEW: 'in review',
  WITHDRAW: 'withdrawn',
  SUPPRESSED: 'suppressed',
};
@connect(
  state => ({
    result: state.doc.getIn(['http', 'closeAction']),
  }),
  actions,
)
class ActionCreate extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      modalVisible: false,
      action: '',
      jsonData: {},
      loading: false,
    };
  }

  onClickHandler = type => {
    const isSuitable = type === 'suitable';

    this.setState({
      action: isSuitable ? 'Suitable' : 'Not Suitable',
      modalVisible: true,
      jsonData: { action_required: !isSuitable },
    });
  };

  formatLabel(key) {
    if (key === 'accreditation_suitability') return 'Accreditation';
    if (key === 'attachment_suitability') return 'Attachment';
    return key;
  }

  getContent = content => {
    const { record } = this.props;
    const label = this.formatLabel(record.actionType.type);
    const actionText = content === 'Suitable'
      ? 'added to their constituent profile'
      : 'marked accordingly in their constituent profile';
    return (
      <>
        You are confirming this{' '}
        {label} is <b>{content}</b> for{' '}
        <b>{record.constituent.fullName}?</b>
        <br />
        <br />
        You are acknowledging that this {label.toLocaleLowerCase()}{' '} is{' '}
        <b>{content}</b> for this person, and it will be {actionText}.
      </>
    );
  };

  handleOk = () => {
    this.setState({ loading: true });
    this.props.closeAction(this.state.jsonData, this.props.record.id);    
    setTimeout(() => {
      message.success('Action closed successfully!');
      this.props.getAllActionsAndDecisions();
      this.props.fetchActionCountByStatus(ACTION_STATUS.NEW);
      this.setState({ loading: false, modalVisible: false });
    }, 2300);
  };

  handleCancel = () => {
    this.setState({ modalVisible: false });
  };

  render() {
    const { modalVisible, action, loading } = this.state;
    const { record } = this.props;
    const accreditationId = record && record.accreditationId;
    return (
      <div>
        <Button
          onClick={() => this.onClickHandler('suitable')}
          type="primary"
          style={{ margin: '2px' }}
        >
          Suitable
        </Button>
        <Button
          onClick={() => this.onClickHandler('not-suitable')}
          style={{ margin: '2px' }}
        >
          Not Suitable
        </Button>
        {modalVisible && (
          <Modal
            title={
              <div style={{ display: 'flex' }}>
                <Icon
                  type="question-circle"
                  style={{
                    color: '#faad14',
                    marginRight: '8px',
                    fontSize: '24px',
                  }}
                />
                <span>Do you want to set this action as {action}?</span>
              </div>
            }
            visible={modalVisible}
            onOk={this.handleOk}
            onCancel={this.handleCancel}
            destroyOnClose={true}
            okButtonProps={{ loading }}
          >
            <div>{this.getContent(action)}</div>
          </Modal>
        )}
      </div>
    );
  }
}

export { ActionCreate };
